import { Calendar } from '@fullcalendar/core';
import iCalendarPlugin from '@fullcalendar/icalendar';
import timeGridPlugin from '@fullcalendar/timegrid';
import deLocale from '@fullcalendar/core/locales/de';

export default class Roster {
    static init() {
        return new Roster();
    }
    
    constructor() {
        this.colors = {
            'Dr. Peter Klar': '#f4d06f',
            'Dr. Julia Saleta': '#ade5f7',
            'Dr. Christiane Kriszt': '#69c4ea',
            'Dr. Christian Pickem': '#b3b8fc',
            'Dr. Claudia  Billensteiner ': '#f896d8',
            'Dr. Birgit  Kager': '#b9e28c',
            'Dr. Christine Fichtl': '#7dcfb6',
            'Dr. med. univ. Vertretungsarzt': '#AD5CB4'
        };

        var calendarEl = document.getElementById('calendar');
        if (!calendarEl)
            return;

        const startDate = new Date(calendarEl.dataset.startDate);
        const endDate = new Date(calendarEl.dataset.endDate);
        let rosterOption = calendarEl.dataset['rosterOption'];

        if (rosterOption === null)
            rosterOption = 'doctors';

        let calendar = new Calendar(calendarEl, {
            businessHours: {
                daysOfWeek: [1, 2, 3, 4, 5, 6, 0], // Monday - Friday
                startTime: '06:00',
                endTime: '21:00'
            },
            events: {
                url: '/calendar/' + rosterOption,
                format: 'ics',
                success: (content, response) => {
                    content.forEach(item => {
                        const title = item.title.split('\n')[0];
                        if (this.colors[title] != null) {
                            item.backgroundColor = this.colors[title];
                            item.borderColor = this.colors[title];
                        }
                    });
                }
            },
            eventColor: '#0AB2E8',
            eventTextColor: '#000000',
            eventBorderColor: '#0AB2E8',
            headerToolbar: {
                left: 'title',
                center: '',
                right: 'prev,next',
            },
            views: {
                timeGridDay: {
                    dayHeaderFormat: { weekday: 'long', day:'numeric', month: 'numeric' },
                },
                timeGridWeek: { 
                    dayHeaderFormat: { weekday: 'long', day:'numeric', month: 'numeric', year:'numeric' },
                }
            },
            slotDuration: '00:30:00',
            height: 'auto',
            allDaySlot: false,
            initialView: window.innerWidth < 770 ? 'timeGridDay' : 'timeGridWeek',
            locale: deLocale,
            slotMinTime: '06:00:00',
            slotMaxTime: '21:00:00',
            nowIndicator: true,
            plugins: [timeGridPlugin, iCalendarPlugin],
            stickyHeaderDates: true,
            stickyFooterScrollbar: true,
            validRange: {
                start: startDate,
                end: endDate,
            }
        });

        calendar.render();
    }
}